import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BannerSlider = ({ sliders }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    // Disable infinite scroll and autoplay when there's only one slide
    const hasMultipleSlides = sliders && sliders.length > 1;
    
    const settings = {
        dots: false,
        infinite: hasMultipleSlides,
        speed: 500,
        slidesToShow: 1,        // Default: desktop
        slidesToScroll: 1,
        autoplay: hasMultipleSlides,
        autoplaySpeed: 3000,
        arrows: false,
        dotsClass: "slick-dots",
    };

  return (
      <Slider {...settings} width="100%">
        {sliders?.map((slide, index) => (
          <Box key={index} sx={{ px: { xs: 0, md: 1 } }}>
            <Box
                component='img'
                src={isMobile ? slide?.mobile_src :  slide?.desktop_src}
                alt={`Slider ${index + 1}`}
                sx={{
                    width: '100%',
                    borderRadius: 2,
                }}
            />
          </Box>
        ))}
      </Slider>
  );
};

export default BannerSlider;